import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../../Image/logo.png";

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);

  const closeMenu = () => {
    setMobileMenu(false);
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img src={logo} alt="logo" />
          <span className="logo-text">
            JALA-E-BIKES
            <p>A RETAIL SHOP</p>
          </span>
        </Link>
      </div>

      {/* Hamburger */}
      <div
        className={`hamburger ${mobileMenu ? "open" : ""}`}
        onClick={() => setMobileMenu(!mobileMenu)}
      >
        <span />
        <span />
        <span />
      </div>

      {/* Nav Links */}
      <ul className={`nav-links ${mobileMenu ? "show" : ""}`}>
        <li className="nav-item">
          <NavLink to="/" onClick={closeMenu}>
            HOME
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/about" onClick={closeMenu}>
            ABOUT
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/products" onClick={closeMenu}>
            PRODUCTS
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink to="/contact" onClick={closeMenu}>
            CONTACT
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
